import * as React from 'react';

var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowDescIcon = function SvgArrowDescIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m433.04,227.37l-128.16-128.16c-12.28-12.28-32.18-12.28-44.46,0-12.28,12.28-12.28,32.18,0,44.46l74.5,74.5H89.2c-17.36,0-31.44,14.07-31.44,31.44s14.07,31.44,31.44,31.44h246.52l-75.3,75.3c-12.28,12.28-12.28,32.18,0,44.46,6.14,6.14,14.18,9.21,22.23,9.21s16.09-3.07,22.23-9.21l128.16-128.16c6.24-6.24,9.29-14.45,9.19-22.63.1-8.18-2.95-16.39-9.19-22.63Z"
  })));
};

export { SvgArrowDescIcon as ReactComponent };
